// extracted by mini-css-extract-plugin
module.exports = {"section":"Tariffs_section__pAhKk","fishes":"Tariffs_fishes__VHpEQ","mobileTitle":"Tariffs_mobileTitle__K3vhB","card":"Tariffs_card__8J5B1"};